export enum BulkLoadRequestStatus {
  QueuedForStaging = "QueuedForStaging",
  FileHeaderError = "FileHeaderError",
  QueuedForValidation = "QueuedForValidation",
  ValidationComplete = "ValidationComplete",
  ValidationReportGenerated = "ValidationReportGenerated",
  QueuedForPISubmission = "QueuedForPISubmission",
  SubmissionComplete = "SubmissionComplete",
  Error = "Error",
}

export enum BulkLoadValidationStatus {
    PASSED = "Passed",
    PARTIALLY_FAILED = "Partially Failed",
    FAILED = "Failed",
}
